<script>
import Layout from "@layouts/form";
import ChamadoFluxoTransicao from "@forms/ChamadoFluxoTransicao";

export default {
  page: {
    title: "Detalhes | Chamado Fluxo Transição"
  },
  components: { Layout, ChamadoFluxoTransicao },
  props: {
    editable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      title: "Chamado Fluxo Transição",
      items: [
        {
          text: "Cadastros",
          href: "/Cadastros"
        },
        {
          text: "Chamado Fluxo Transição",
          href: "/ChamadoFluxoTransicao"
        },
        {
          text: "Edição",
          active: true
        }
      ]
    };
  }
};
</script>

<template>
  <Layout :title="title" :items="items">
    <div class="page-content">
      <ChamadoFluxoTransicao :editable="editable"></ChamadoFluxoTransicao>
    </div>
  </Layout>
</template>
